import { DEPENDENCY_UPDATE_EVENT } from './events'
import { ValueDependencyBehaviour } from './dependency_behaviours/value'
import { OptionsDependencyBehaviour } from './dependency_behaviours/options'
import { TextDependencyBehaviour } from './dependency_behaviours/text'

export class Dependency {
  constructor(config, form) {
    this.config = config
    this.form = form

    const BehaviourClass = this._getDependencyBehaviourClass()
    this.behaviour = new BehaviourClass(config.behaviour, this)
  }

  get type() {
    return this.config.dependency_type
  }

  get trackingFieldInput() {
    const inputs = this.form.element.querySelectorAll(`[name="${this.config.tracking_field}"]`)
    if (inputs.length === 1) return inputs[0]
    // Multiple inputs (e.g. radio or checkbox set)
    return Array.from(inputs).find(input => input.checked) || inputs[0]
  }

  get trackingFieldName() {
    return this.config.tracking_field
  }

  get eventType() {
    return this.config.event_type
  }

  matches(inputElement) {
    return this.config.dependent_field === inputElement.name
  }

  subscribeToFormUpdates(listener) {
    this.form.on(DEPENDENCY_UPDATE_EVENT, event => {
      // targetName = the name of the input that triggered the update event
      // eventType = the html input event type that triggered the update - e.g. on 'change' or on 'input'
      const { targetName, eventType } = event.detail

      if (targetName === this.trackingFieldName && eventType === this.eventType) {
        listener(this)
      }
    })
  }

  _getDependencyBehaviourClass() {
    switch (this.type) {
      case 'Forms::Dependencies::ValueBehaviour':
        return ValueDependencyBehaviour
      case 'Forms::Dependencies::OptionsBehaviour':
        return OptionsDependencyBehaviour
      case 'Forms::Dependencies::TextBehaviour':
        return TextDependencyBehaviour
      // Add more cases here for other dependency types as needed
      default:
        throw new Error(`No behaviour class for ${this.type}`)
    }
  }

  static fromList(dependencies, form) {
    return dependencies.map(config => new this(config, form))
  }
}
